import CryptoJS from 'crypto-js/crypto-js'

export function randomNum(randomFlag, min, max){
    var str = "",
        range = min,
        arr = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    // 随机产生
    if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
    }
    let pos = 0;
    for(var i=0; i<range; i++){
        pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
    }
    return str;
}

export function decrypt(string) {
    let IV  = '397e2eb61307109f';
    let KEY = '6e68006ebcb62f98';

    var key = CryptoJS.enc.Utf8.parse(KEY);
    var iv = CryptoJS.enc.Utf8.parse(IV);

    //服务端返回的是hex字符串数据，先转成base64，再解密
    const WordArray = CryptoJS.enc.Hex.parse(string);
    const base64str = CryptoJS.enc.Base64.stringify(WordArray);
    var decrypted = CryptoJS.AES.decrypt(base64str, key, {
        iv:iv,
        padding:CryptoJS.pad.Pkcs7
    });
    //console.log(decrypted.toString(CryptoJS.enc.Utf8));
    return decrypted.toString(CryptoJS.enc.Utf8);
}


// WEBPACK FOOTER //
// ./src/api/helper/index.js